<template>
  <div class="layouts">
    <el-container>
      <el-aside :width="asideWidth">
        <div class="logo" :class="{ 'hideLoge': flag }"></div>
        <VMenu :isFlag="flag"></VMenu>
      </el-aside>
      <el-container class="wrap">
        <el-header :class="{ 'collapse': flag }">
          <VHeader @isCollapse="isCollapse"></VHeader>
        </el-header>
        <el-main class="myMain">
          <router-view />
        </el-main>
        <!-- <el-footer height="40px" v-if="isMap">
          <VFooter></VFooter>
        </el-footer> -->
      </el-container>
    </el-container>
  </div>
</template>

<script>
import VMenu from '@/components/menu/menu.vue'
import VHeader from '@/components/header/header.vue'
import VFooter from '@/components/footer/footer.vue'

export default {
  name: 'Layouts',
  data () {
    return {
      flag: false,
      asideWidth: '240px',
      isMap: true // 是否为GIS地图
    }
  },
  mounted () {
    if (this.$route.path === '/map') {
      this.isMap = true
    } else {
      this.isMap = false
    }
  },
  methods: {
    isCollapse (flag) {
      this.flag = flag
      if (flag) {
        this.asideWidth = '64px'
      } else {
        this.asideWidth = '240px'
      }
    }
  },
  watch: {
    $route (to, form) {
      if (this.$route.path === '/map') {
        this.isMap = true
      } else {
        this.isMap = false
      }
    }
  },
  components: {
    VHeader,
    VFooter,
    VMenu
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus">
.layouts
  width 100%
  height 100%
  .el-container
    width 100%
    height 100%
    &.wrap
      position relative
    .el-aside
      background-color #262C36
      overflow-x hidden
      .logo
        margin 8px auto
        width 158px
        height 44px
        background-image url('../../assets/img/logo_white.png')
        background-repeat no-repeat
        background-size 100% 100%
        &.hideLoge
          width 44px
          background #262C36
          // background-image url('../../assets/img/logo_hide.png')
    .el-header
      position fixed
      top 0
      left 240px
      right 0
      padding 0
      z-index 100
      &.collapse
        left 64px
    .el-main
      &.myMain
        padding 0
        background-color #F5F7FA
    .el-footer
      position absolute
      bottom 0
      left 0
      padding 0
      width 100%
</style>



// WEBPACK FOOTER //
// src/components/layouts/layouts.vue